import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goatobelgaumcab() {



    const cardData = {


keyword: "Goa to Belgaum Cab",

headingDescription: "Belgaum Taxi Service offers dependable Goa to Belgaum cab services for airport transfers, railway station pickups, business travel, family trips, hotel transfers, sightseeing, and one-way or round-trip journeys. Whether you are traveling from North Goa, South Goa, Dabolim Airport, Mopa Airport, or any beach destination, we provide safe, comfortable, and affordable taxi services with professional chauffeurs. Our fleet includes Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium vehicles suitable for solo travelers, families, and groups. With doorstep pickup, transparent pricing, flexible departure timings, easy online booking, well-maintained vehicles, and 24/7 customer support, Belgaum Taxi Service ensures a smooth and hassle-free journey from Goa to Belgaum. We provide cab services from all major tourist destinations, airports, hotels, and resorts across Goa directly to Belgaum and nearby locations.",

topPlaces: [
  {
    title: "Belagavi Airport",
    description: "Belagavi Airport is a convenient destination for business and leisure travelers arriving from Goa. Our cab service provides timely airport transfers with comfortable and reliable transportation."
  },
  {
    title: "Belagavi Fort",
    description: "Belagavi Fort is one of the city's most iconic historical landmarks, known for its ancient architecture, temples, and peaceful surroundings. It is a popular destination for tourists visiting Belgaum."
  },
  {
    title: "KLE Hospital",
    description: "KLE Hospital is one of North Karnataka's leading multi-specialty hospitals. Many passengers travel from Goa to Belgaum for medical consultations, treatments, and healthcare services."
  },
  {
    title: "VTU Belagavi",
    description: "Visvesvaraya Technological University (VTU) attracts students, faculty members, and academic visitors from different parts of India, making it a frequent cab destination."
  },
  {
    title: "Udyambag Industrial Area",
    description: "Udyambag is a major industrial hub in Belgaum, housing engineering companies, manufacturing units, and commercial establishments. It is a preferred destination for corporate travelers."
  },
  {
    title: "Tilakwadi",
    description: "Tilakwadi is a prominent residential and commercial locality with educational institutions, restaurants, shopping areas, and business establishments, making it a common drop location."
  },
  {
    title: "Kapileshwar Temple",
    description: "Kapileshwar Temple is one of the oldest and most respected temples in Belgaum, attracting devotees throughout the year for religious visits."
  },
  {
    title: "Gokak Falls",
    description: "Gokak Falls, located near Belgaum, is a spectacular waterfall surrounded by scenic landscapes and is one of Karnataka's most popular natural attractions."
  },
  {
    title: "Amboli",
    description: "Amboli is a beautiful hill station near Belgaum, famous for waterfalls, mist-covered hills, lush forests, and pleasant weather, making it an ideal stop for nature lovers."
  },
  {
    title: "Khanapur",
    description: "Khanapur is a picturesque town near Belgaum known for its greenery, forests, and peaceful surroundings. It is a popular nearby destination for travelers arriving from Goa."
  }
],




"services": [
  {
    "name": "Goa to Belgaum Cab",
    "description": "Book Goa to Belgaum Cab for safe, comfortable, and reliable one way or round trip travel with experienced chauffeurs, clean AC Sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles. Enjoy fixed fares, doorstep pickup, online booking, airport transfers, family trips, business travel, luggage assistance, and 24×7 customer support."
  },
  {
    "name": "Goa to Belgaum Taxi",
    "description": "Choose Goa to Belgaum Taxi for affordable intercity travel with professional drivers, transparent pricing, sanitized vehicles, flexible pickup timing, and smooth highway journeys."
  },
  {
    "name": "Goa to Belgaum Cab Service",
    "description": "Our Goa to Belgaum Cab Service offers reliable transportation with AC vehicles, experienced chauffeurs, fixed pricing, online reservations, and comfortable outstation travel."
  },
  {
    "name": "Goa to Belgaum Taxi Service",
    "description": "Travel with Goa to Belgaum Taxi Service offering premium cab options, punctual pickup, safe driving, affordable fares, and hassle-free travel for tourists, families, and corporate travelers."
  },
  {
    "name": "Goa to Belgaum One Way Cab",
    "description": "Book Goa to Belgaum One Way Cab with instant confirmation, economical fares, comfortable vehicles, and direct drop service without return charges."
  },
  {
    "name": "Goa to Belgaum Cab Booking",
    "description": "Reserve Goa to Belgaum Cab Booking online with quick confirmation, multiple vehicle options, secure reservations, and 24×7 customer assistance."
  },
  {
    "name": "Goa to Belgaum Car Rental",
    "description": "Hire Goa to Belgaum Car Rental for flexible travel with Sedan, Ertiga, Innova Crysta, SUVs, and chauffeur-driven vehicles suitable for every journey."
  },
  {
    "name": "Goa to Belgaum Outstation Cab",
    "description": "Choose Goa to Belgaum Outstation Cab for long-distance travel with clean AC cars, fixed fares, experienced drivers, and comfortable highway rides."
  },
  {
    "name": "Goa to Belgaum Airport Cab",
    "description": "Book Goa to Belgaum Airport Cab for timely airport pickups and drops with luggage assistance, professional chauffeurs, and reliable intercity transfers."
  },
  {
    "name": "Goa Airport to Belgaum Cab",
    "description": "Reserve Goa Airport to Belgaum Cab with direct airport pickup, fixed pricing, AC vehicles, and comfortable travel to Belgaum without delays."
  },
  {
    "name": "Goa Airport to Belgaum Taxi",
    "description": "Travel with Goa Airport to Belgaum Taxi featuring experienced drivers, spacious luggage capacity, transparent fares, and 24×7 airport transportation."
  },
  {
    "name": "North Goa to Belgaum Cab",
    "description": "Book North Goa to Belgaum Cab with doorstep pickup from Calangute, Candolim, Baga, Anjuna, Vagator, and other locations using premium chauffeur-driven vehicles."
  },
  {
    "name": "South Goa to Belgaum Cab",
    "description": "Choose South Goa to Belgaum Cab for comfortable transfers from Colva, Benaulim, Palolem, Varca, Cavelossim, and nearby areas with fixed fares."
  },
  {
    "name": "Goa to Belgaum Innova Cab",
    "description": "Reserve Goa to Belgaum Innova Cab for family vacations, group travel, corporate trips, airport transfers, and spacious luggage accommodation."
  },
  {
    "name": "Goa to Belgaum Ertiga Cab",
    "description": "Book Goa to Belgaum Ertiga Cab for affordable six-seater travel with comfortable seating, experienced chauffeurs, and reliable intercity transportation."
  },
  {
    "name": "Goa to Belgaum Round Trip Cab",
    "description": "Hire Goa to Belgaum Round Trip Cab with flexible return schedules, transparent pricing, premium vehicles, and convenient travel planning."
  },
  {
    "name": "Goa to Belgaum Tour Package by Cab",
    "description": "Choose Goa to Belgaum Tour Package by Cab for sightseeing, holiday travel, customized itineraries, experienced drivers, and comfortable outstation journeys."
  },
  {
    "name": "Cheap Goa to Belgaum Cab",
    "description": "Book Cheap Goa to Belgaum Cab with budget-friendly fares, clean AC vehicles, reliable service, and no hidden charges."
  },
  {
    "name": "Best Goa to Belgaum Cab Service",
    "description": "Experience the Best Goa to Belgaum Cab Service with professional chauffeurs, premium vehicles, fixed fares, punctual pickup, and excellent customer support."
  },
  {
    "name": "Online Goa to Belgaum Cab Booking",
    "description": "Complete Online Goa to Belgaum Cab Booking with instant confirmation, secure reservations, multiple vehicle choices, and round-the-clock booking assistance."
  }
],

"tableData": [
  ["Goa to Belgaum Cab", "Goa to Belgaum Taxi"],
  ["Goa to Belgaum Cab Service", "Goa to Belgaum Taxi Service"],
  ["Goa to Belgaum One Way Cab", "Goa to Belgaum Cab Booking"],
  ["Goa to Belgaum Car Rental", "Goa to Belgaum Outstation Cab"],
  ["Goa to Belgaum Airport Cab", "Goa Airport to Belgaum Cab"],
  ["Goa Airport to Belgaum Taxi", "North Goa to Belgaum Cab"],
  ["South Goa to Belgaum Cab", "Goa to Belgaum Innova Cab"],
  ["Goa to Belgaum Ertiga Cab", "Goa to Belgaum Round Trip Cab"],
  ["Goa to Belgaum Tour Package by Cab", "Cheap Goa to Belgaum Cab"],
  ["Best Goa to Belgaum Cab Service", "Online Goa to Belgaum Cab Booking"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Goa to Belgaum Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service offers dependable Goa to Belgaum cab services with experienced drivers, comfortable vehicles, and safe travel for every journey."
  },
  {
    WhyChooseheading: "Pickup from Anywhere in Goa",
    WhyChoosedescription: "Schedule convenient pickup from North Goa, South Goa, Dabolim Airport, Mopa Airport, railway stations, hotels, resorts, beaches, or any preferred location."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Every Trip",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your group size, luggage, and travel preferences."
  },
  {
    WhyChooseheading: "Professional Drivers with Route Expertise",
    WhyChoosedescription: "Our courteous chauffeurs are familiar with Goa–Belgaum routes, ensuring a smooth, safe, and comfortable ride throughout the journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Cab Options",
    WhyChoosedescription: "Whether you're planning a one-way transfer or a return journey, we provide flexible cab booking options to match your schedule."
  },
  {
    WhyChooseheading: "Affordable Taxi Fare with Transparent Pricing",
    WhyChoosedescription: "Travel confidently with competitive cab rates, upfront quotations, and no hidden charges for your Goa to Belgaum trip."
  },
  {
    WhyChooseheading: "Suitable for Tourists & Business Travelers",
    WhyChoosedescription: "Our Goa to Belgaum cabs are ideal for family vacations, airport transfers, corporate travel, sightseeing, and weekend getaways."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Book your Goa to Belgaum taxi anytime with instant confirmation and dedicated customer assistance for a hassle-free travel experience."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Goa to Belgaum cab service?",
    answer: "Yes, Belgaum Taxi Service offers reliable one-way and round-trip cab services from Goa to Belgaum."
  },
  {
    question: "Can I book a one-way cab from Goa to Belgaum?",
    answer: "Yes, one-way taxi services are available with pickup from any location across Goa."
  },
  {
    question: "Do you provide pickup from Goa airports?",
    answer: "Yes, pickup is available from Dabolim Airport, Mopa Airport, railway stations, hotels, resorts, and other locations across Goa."
  },
  {
    question: "Which vehicles are available for Goa to Belgaum travel?",
    answer: "Our fleet includes Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable intercity travel."
  },
  {
    question: "Is Goa to Belgaum cab service available 24/7?",
    answer: "Yes, our taxi services are available round the clock for early morning, daytime, and late-night travel."
  },
  {
    question: "Can I book a return cab from Belgaum to Goa?",
    answer: "Yes, round-trip and return taxi services are available with flexible travel schedules."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless mentioned in the confirmed quotation."
  },
  {
    question: "Can I stop at sightseeing places during the journey?",
    answer: "Yes, customized travel plans with en-route sightseeing or refreshment stops can be arranged on request."
  },
  {
    question: "Is this service suitable for airport transfers and family travel?",
    answer: "Yes, our Goa to Belgaum cab service is ideal for airport transfers, family vacations, business travel, and group trips."
  },
  {
    question: "How can I book a Goa to Belgaum Cab?",
    answer: "Share your pickup location, Belgaum destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Naik",
    feedback: "The Goa to Belgaum cab service was punctual and comfortable. The driver was professional, the vehicle was clean, and the journey was relaxing from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shruti Kulkarni",
    feedback: "We booked a taxi from Goa after our vacation, and everything was managed perfectly. The ride was smooth, the cab was spacious, and the overall experience was excellent.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goa to Belgaum Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/goa-to-belgaum-cab.webp",
  "description":
    "Book Goa to Belgaum Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Goa, Goa Airport, and nearby locations to Belgaum with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/goa-to-belgaum-cab"
  }
};






    return (
        <div>


<Helmet>
  <title>Goa to Belgaum Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Goa to Belgaum Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Travel from Goa, Goa Airport to Belgaum with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 at affordable fares."
  />

  <meta
    name="keywords"
    content="goa to belgaum cab, goa to belgaum taxi, goa airport to belgaum taxi, goa to belgaum cab fare, goa to belgaum distance by cab, goa to belgaum taxi cost, goa to belgaum taxi fare, Goa to Belgaum Cab, Goa to Belgaum Taxi, Goa to Belgaum Cab Service, Goa to Belgaum Taxi Service, Goa Belgaum One Way Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Goatobelgaumcab;